import { render } from "./PriceEdit.vue?vue&type=template&id=5417de20&ts=true"
import script from "./PriceEdit.vue?vue&type=script&lang=ts"
export * from "./PriceEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__